import { logErrorToConsole } from '../../constants';

const getAllCabinsInFlightItinerary = (flightItinerary) => {
  try {
    return flightItinerary.flightSegments
      .map((x) => x.flights.map((y) => y.originalCabinClass))
      .flat();
  } catch (error) {
    logErrorToConsole('[ERROR] occured in getAllCabinsInFlightItinerary: ', error);
    return [];
  }
};

export default getAllCabinsInFlightItinerary;
